import React, { FC } from 'react'

import { ToggleButtonProps } from '../../../ToggleButton'

import * as SC from './styled'

export type FormFieldToggleButtonProps = ToggleButtonProps & {
  name: string
  checked?: boolean
  helpText?: string
  error?: string
  hasError?: boolean
}

const FormFieldToggleButton: FC<FormFieldToggleButtonProps> = ({
  error,
  helpText,
  ...toggleButton
}) => {
  return (
    <SC.Container>
      <SC.Button {...toggleButton} />
      {!error && helpText && <SC.Help>{helpText}</SC.Help>}
      {error && <SC.Error>{error}</SC.Error>}
    </SC.Container>
  )
}

export default FormFieldToggleButton
